import { Form as FormikForm } from 'formik';
import styled, { css } from 'styled-components';

import { captionRegular } from 'styles/mixins/fonts';

import { SummaryPricesCard } from './summary-prices-card';

export const SummaryCard = styled(SummaryPricesCard)`
  ${({ theme }) => css`
    ${theme.responsive.isDesktop &&
    css`
      width: 30%;
    `}
  `}
`;

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  gap: 16px;

  ${({ theme }) => css`
    ${theme.responsive.isMobile &&
    css`
      flex-direction: column;
      gap: 8px;
    `}
  `};
`;

export const Subtitle = styled.p`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;
